// Versions of the public legal texts; a text change needs a new version so each application records what it accepted.
// .2 (Kaan, 5 Kasım ~09:40): fee and payment per the 22 Ekim model; 12-month non-circumvention.
export const TERMS_VERSION = '2026-11-05.2';
